export default {
    title: "Батафсил маълумот",

    position: {
        label: "Ҳужжат позицияси",
        placeholder: "Позицияни танланг",
        id: "ID",
        product: "Товар",
        quantity: "Миқдор",
    },

    tabs: {
        main: "Асосий",
        product: "Товар",
        bank: "Банк",
        prices: "Нархлар",
        delivery: "Етказиб бериш",
    },

    main: {
        id: "ID",
        lotId: "Lot ID",
        vat: "ҚҚС",
        unit: "Ўлчов бирлиги",
        quantity: "Миқдор",
        expense: "Харажат",
        country: "Мамлакат",
        countryCode: "Мамлакат коди",
        claimId: "Claim ID",
        description: "Тавсиф",
    },

    product: {
        id: "ID",
        code: "Код",
        name: "Номи",
    },

    bank: {
        klsId: "KLS ID",
        name: "KLS номи",
        bank: "Банк",
        company: "Компания",
        account: "Банк ҳисоб рақами",
        mfo: "МФО",
        accountType: "Ҳисоб рақами тури",
    },

    prices: {
        unitPrice: "Бирлик нархи",
        suggestedPrice: "Таклиф қилинган нарх",
        totalCost: "Умумий қиймат",
        suggestedTotalCost: "Таклиф қилинган умумий қиймат",

        withoutVat: "ҚҚСсиз",
        vat: "ҚҚС",
        withVat: "ҚҚС билан",
    },

    delivery: {
        period: "Етказиб бериш даври",
        days: "Етказиб бериш муддати",
        daysValue: "{{count}} кун",
        schedule: "Етказиб бериш графиги",

        year: "Йил",
        month: "Ой",
        quantity: "Миқдор",
        advancePayment: "Аванс",

        empty: "Етказиб бериш графиги мавжуд эмас",
    },

    common: {
        dash: "—",
        noData: "Кўрсатиш учун маълумот мавжуд эмас",
        selectPosition: "Позицияни танланг",
    },
};